import { Notification } from '@/types/other';
import checkArray from '@/utilites/check-array';

export default async function getNotifications_v2(
  page: number | undefined = 1,
  limit: number | undefined = 10
): Promise<Notification[]> {
  try {
    const response = await fetch(`/api/get-notifications`, {
      method: 'POST',
      body: JSON.stringify({ page, limit }),
      headers: {
        'Content-Type': 'application/json',
      },
    });
    if (!response.ok) {
      throw new Error('Failed to fetch bottle of the day');
    }
    const notifications = await response.json();
    if (checkArray<Notification>(notifications)) {
      return notifications.sort((a, b) => {
        return new Date(b.created).valueOf() - new Date(a.created).valueOf();
      });
    }
    throw new Error('Failed to fetch bottle of the day');
  } catch (e) {
    throw new Error('Failed to fetch bottle of the day');
  }
}
